
import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectCreate from "components/Varios/SelectCreate.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardMencionesHonor from "components/Varios/CardMencionesHonor.js";

//import FileUpload from "components/Varios/FileUpload.js";
//import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';
import { mensajeCamposIncompletos } from './constants';

const id = 1043;
const API_URL = configData.SERVER_URL

export class MencionesHonorData {
    idmencionhonor: number = 0;
    idpersona: number = 0;

    fecha: string = "";
    idpais: number = 0;
    idinstitucion: number = -1;
    
    institucion: string = "";
    nombremencion: string = "";
    refarchivo: string = "";
    strPais: string = "";
}


interface MencionesHonorDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: MencionesHonorData;
    MencionesHonorDataList: MencionesHonorData[];
    paisList: Array<any>;
    institucionList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
}

export class MencionesHonor extends React.Component<RouteComponentProps<{}>, MencionesHonorDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new MencionesHonorData(),
            MencionesHonorDataList: [], paisList: [], institucionList: [], error: null, tiposEvidencia: [], filesData: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarMencionesHonor = this.cargarMencionesHonor.bind(this);
        this.cargarInstituciones = this.cargarInstituciones.bind(this);
        this.handleSelectChangeInstitucion = this.handleSelectChangeInstitucion.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarMencionesHonor();
                }
            }
        );
    }

    cargarDatos() {
        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosEscalafon/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            paisList: result.entTabla.map(d => ({
                                "value": d.idpais,
                                "label": d.nombre
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        paisList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    //API PARA OBTENER INFORMACIÓN ACADÉMICA DE PERSONA
    cargarMencionesHonor() {
        fetch(API_URL + "InformacionAcademica/MencionhonorDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            MencionesHonorDataList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(filesData)
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener la información académica.")
                    }
                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        MencionesHonorDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarInstituciones(idPais) {
        var dto = this.state.dtoData;
        dto['idpais'] = idPais;
        this.setState({
            dtoData: dto,
        });

        fetch(API_URL + "InformacionAcademica/InstitucionByIdPais/" + idPais)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {

                        this.setState({
                            institucionList: result.entTabla.map(d => ({
                                "value": d.idinstitucion,
                                "label": d.nombre
                            })),
                        });

                        if (this.state.dtoData["idinstitucion"] === 0 && this.state.dtoData["institucion"] != "") {
                            //console.log(this.state.institucionList)
                            let newList = this.state.institucionList
                            newList.push({ "value": 0, "label": this.state.dtoData["institucion"] })
                            //console.log(newList)
                            this.setState({
                                institucionList: newList
                            });
                        }
                        
                        //console.log(this.state.institucionList)

                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las instituciones.")
                    }
                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        institucionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        this.setState({
            dtoData: dto,
        });
    }

    handleSelectChangeInstitucion(value, name, tipo = null, label) {
        var dto = this.state.dtoData;
        
        dto[name] = value;
        dto['institucion'] = label;
        this.setState({ dtoData: dto });

    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        //console.log("tipoEvidencia = " + JSON.stringify(tipoEvidencia) + " uploadFile=" + JSON.stringify(uploadFile));
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
            tiposEvidencia: this.cargarEvidencias(fileInfoState)
        });
        //console.log("state.filesData = " + JSON.stringify(fileInfoState));
    }

    cargarEvidencias(filesData: any[]) {
        var tiposEvidencia = [
                { "value": "MEN", "label": "Certificado de mención de honor " + filesData.filter(f => f.type == "MEN").map(ff => ': ' + ff.file.name).join(', ') }
            ];
        return tiposEvidencia;
    }

    descargarEvidencias(infoAcademica: MencionesHonorData) {
        var evidencias = new Array();
        if (infoAcademica.refarchivo) {
            evidencias.push({ name: "MEN" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "InformacionAcademica/Mencionhonor/Refarchivo/" + infoAcademica.idmencionhonor });
        }
        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new MencionesHonorData(), institucionList: [] });
    }

    onClickEdit(idmencionhonor) {
        this.setState({
            dtoData: new MencionesHonorData()
        });

        fetch(API_URL + "InformacionAcademica/MencionhonorByIdmencionhonor/" + idmencionhonor)
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(filesData),
                            loading: false
                        });

                        if (result.entTabla[0]["idpais"]) {
                            this.cargarInstituciones(result.entTabla[0]["idpais"])
                        }

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);

                    } else {
                        alertService.error(result["strMensaje"])
                    }

                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        dtoData: new MencionesHonorData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idmencionhonor) {
        fetch(API_URL + "FormularioController/DeleteDatosMencionHonor/" + idmencionhonor, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("La información académica se eliminó correctamente.")
                        this.cargarMencionesHonor();
                    }
                })
    }

    private postFiles(postFilesUrl, filesData, identidad) {
        //console.log("filesData = " + JSON.stringify(filesData));
        if (filesData.length > 0) {
            var formFilesData = new FormData();

            filesData.map((fileData) => {
                formFilesData.append("files", fileData.file, fileData.file.name);
                //console.log("append = " + fileData.file.name);
            });

            formFilesData.append('identidad', identidad);
            //console.log("formFilesData = " + JSON.stringify(formFilesData));
            fetch(API_URL + postFilesUrl, {
                method: 'POST',
                body: formFilesData
            })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error("Ocurrió un error al guardar las evidencias.")
                    }
                    else if (responseJson["strEstado"] === "S") {

                        alertService.success("Las evidencias se cargaron exitosamente");
                    }
                },
                (error) => {
                    alertService.error("Ocurrió un error al cargar las evidencias.")
                }
            );
        }
    }

    private handleSave(event) {    
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;

            if (clave === 'fecha') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }

        });

        if (isNaN(dto.idinstitucion)) {
            dto["idinstitucion"] = 0;
        }

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "entidad": dto,
        });

        //console.log(data)

        if (formIsValid) {
            if (dto.idmencionhonor === 0) {
                fetch(API_URL + "FormularioController/PostDatosMencionHonor", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(mensajeCamposIncompletos())
                            }
                            else if (responseJson["strEstado"] === "S") {

                                alertService.success("La mención de honor se ha registrado correctamente.");

                                this.postFiles("FormularioController/PostFilesDatosInformacionAcademica/MencionHonor", filesData, responseJson.entidad.idmencionhonor);
                                this.cargarMencionesHonor();
                                this.onClickLimpiar();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }

                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosMencionHonor", {

                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La mención de honor se ha actualizado correctamente.");
                                this.postFiles("FormularioController/PostFilesDatosInformacionAcademica/MencionHonor", filesData, responseJson.entidad.idmencionhonor);
                                this.onClickLimpiar();
                                this.cargarMencionesHonor();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        }
                    )
            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }

    }

    public render() {

        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.MencionesHonorDataList, this.state.paisList, this.state.institucionList, this.state.tiposEvidencia);
        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(MencionesHonorDataList: Array<any>, paisList: Array<any>, institucionList: Array<any>, tiposEvidencia: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">MENCIONES DE HONOR</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form onSubmit={this.handleSave}>
                                        <Row form>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="nombremencion">Nombre*</Label>
                                                    <Input maxLength="64" type="text" name="nombremencion" id="nombremencion" value={this.state.dtoData.nombremencion} onChange={this.handleChange} required />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <Label for="fecha">Fecha</Label>
                                                <Datepicker
                                                    value={this.state.dtoData.fecha}
                                                    name="fecha"
                                                    id="fecha"
                                                    onChange={this.handleSelectChange}
                                                />
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="idpais">País*</Label>
                                                    <SelectItem
                                                        options={paisList}
                                                        value={this.state.dtoData.idpais}
                                                        onChange={this.cargarInstituciones}
                                                        placeholder=""
                                                        name="idpais"
                                                        id="idpais"
                                                        icon="pais"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="institucion">Institución que otorga*</Label>
                                                    <SelectCreate
                                                        options={institucionList}
                                                        value={this.state.dtoData.idinstitucion}
                                                        onChange={this.handleSelectChangeInstitucion}
                                                        placeholder=""
                                                        name="idinstitucion"
                                                        id="idinstitucion"
                                                        icon="fa-caret-right"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <Label for="fechagraduacion">Evidencia</Label>
                                                <FormGroup row>
                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                        <InputFileUpload
                                                            icon="upload"
                                                            onChange={this.handleFileUploadChange}
                                                            name="MEN"
                                                            placeholder={this.state.dtoData.refarchivo ? "Actualizar Certificado de mención de honor" : "Subir Certificado de mención de honor"} />
                                                    </Col>
                                                    <InputFileDownload tipo="certificado de mención de honor"
                                                        id="downloadRef"
                                                        refarchivo={this.state.dtoData.refarchivo}
                                                        name={"MEN" + this.state.currentUser.identificacion + ".PDF"}
                                                        url={API_URL + "InformacionAcademica/Mencionhonor/Refarchivo/" + this.state.dtoData.idmencionhonor}
                                                    />
                                                </FormGroup>
                                            </Col>

                                        </Row>

                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        
                                    </form >
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {MencionesHonorDataList.map((dto, index) =>
                                                <CardMencionesHonor
                                                    key={dto.idmencionhonor}
                                                    objeto={dto}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + MencionesHonorDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.idmencionhonor)}
                                                    eventDelete={() => this.onClickDelete(dto.idmencionhonor)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default MencionesHonor;